import './contactt.css';
import { Link} from 'react-router-dom';

function Appcontact() {
  const contacts = [
    { number: '+2203475843', href: 'https://www.whatsapp.com' },
    { number: '+2209914708', href: 'https://www.whatsapp.com' },
  ];

  return (
    <footer className="footer">
      <h2>Contact Us Today</h2>

      <div className="content-wrapper">
        {contacts.map((contact, index) => (
          <a
            key={index}
            href={contact.href}
            className="nav-item"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="icon"
              src="/images/whatsap.jpeg"
              alt={`WhatsApp icon for ${contact.number}`}
            />
            <span className="contact-text">WhatsApp: {contact.number}</span>
          </a>
        ))}

        <a
          href="https://www.facebook.com/profile.php?id=61566743746452"
          className="nav-item"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="icon"
            src="/images/facebook.jpeg"
            alt="Facebook icon"
          />
          <span className="contact-text">Follow us</span>
        </a>
        <Link to='/create/message' className='btn btn-light my-3'>
          Send Message
        </Link>
      </div>
    </footer>
  );
}

export default Appcontact;